import type * as C from "@zooi/contracts";
import type { ReactNode } from "react";
import { NEW_PRODUCT_LABELS as N } from "./labels.ts";
import { Callout, CopyButton } from "./ui.tsx";

// Cloud agents (OpenAI dots, Grok Bot) install no plugin: they add zooi's
// remote MCP server and follow plugin/CLOUD.md (docs/product-decisions.md,
// 2026-11-01). Shown when adding a product and on its Agent and runs page.

/** Public, so the agent can read it without zooi: the plugin repository's copy of plugin/CLOUD.md. */
export const CLOUD_GUIDE = "https://github.com/ZooiAI/zooi-plugin/blob/main/CLOUD.md";

/** The prompt that names the product for a cloud agent. */
export const cloudPrompt = (product: Pick<C.Product, "id" | "name" | "url" | "source">) => N.cloudPrompt(product, window.location.origin, CLOUD_GUIDE);

/** The server address, the consent, and the setup prompt; `footer` holds the copy button and, when adding a product, the connection status. */
export function CloudAgentSteps({ footer }: { footer: ReactNode }) {
  const server = `${window.location.origin}/mcp`;
  return <>
    <Callout>{N.cloudNote} <a className="z-link" href={CLOUD_GUIDE} target="_blank" rel="noreferrer">{N.cloudGuide}</a></Callout>
    <ol className="z-setup-steps">
      <li>
        <h3>{N.cloudServer}</h3>
        <p className="z-small z-muted">{N.cloudServerNote}</p>
        <div className="z-cli"><pre className="z-mono">{server}</pre><CopyButton text={server} /></div>
      </li>
      <li>
        <h3>{N.authorize}</h3>
        <p className="z-small z-muted">{N.authorizeCloud}</p>
      </li>
      <li>
        <h3>{N.onboard}</h3>
        <p className="z-small z-muted">{N.cloudOnboardNote}</p>
      </li>
    </ol>
    {footer}
  </>;
}
